import { getPageIdInfo } from "../../utils/common";
import Url from 'url-parse';
import lego from "../../lego";
import { setCookie } from "../../utils/cookie";

/*
触发 zpmclick  dom 结构事例：

 <div zz-sectionid="abc">
  <p zz-sortid="0" zz-sortname="hello" zz-other="123" zz-infoid="" zz-url="" zz-backup="">
    <span> xxx </span>
  </p>
  <p zz-sortid="1" zz-sortname="hello1" zz-other="123" zz-infoid="" zz-url="" zz-backup="">
    <span> xxx </span>
  </p>
</div>

*/

var ZZ_SECTION_ID = 'zz-sectionid';
var ZZ_SORT_ID = 'zz-sortid';
var ZZ_SORT_NAME = 'zz-sortname';
var ZZ_OTHER_ID = 'zz-other';
var ZZ_INFO_ID = 'zz-infoid';
var ZZ_URL = 'zz-url';
var ZZ_BACKUP = 'zz-backup';
// 支持特殊case 不让发送
var NO_SEND = 'zz-nosendclick';
var sendData = function sendData(obj) {
  lego.send(obj);
};
function clickCallback(event) {
  if (document.querySelector) {
    var ele = document.querySelector("[".concat(ZZ_SECTION_ID, "]"));
    if (!ele) return;
  }
  var pageIdInfo = getPageIdInfo();
  if (!pageIdInfo) return;
  var target = event.target;
  var sectionId = '';
  var sortId = target.getAttribute(ZZ_SORT_ID);
  var sortName = target.getAttribute(ZZ_SORT_NAME);
  var other = target.getAttribute(ZZ_OTHER_ID);
  var infoId = target.getAttribute(ZZ_INFO_ID);
  var url = target.getAttribute(ZZ_URL);
  var backupInfo = target.getAttribute(ZZ_BACKUP);
  var jumpurl = '';
  var jumppagequery = '';
  var parent = target.parentElement;
  var nosend = '';
  var nodeArr = [target];
  while (parent && !sectionId) {
    nodeArr.push(parent);
    // 获取 sectionId ， 获取到 则退出循环
    sectionId = parent.getAttribute(ZZ_SECTION_ID) || target.getAttribute(ZZ_SECTION_ID);
    var noSendFlag = parent.getAttribute(NO_SEND) || target.getAttribute(NO_SEND);
    if (noSendFlag) nosend = noSendFlag;

    // 没获取到 attribute， 则取父级
    if (other === undefined || other === null) {
      other = parent.getAttribute(ZZ_OTHER_ID);
    }
    if (sortId === undefined || sortId === null) {
      sortId = parent.getAttribute(ZZ_SORT_ID);
    }
    if (sortName === undefined || sortName === null) {
      sortName = parent.getAttribute(ZZ_SORT_NAME);
    }
    if (infoId === undefined || infoId === null) {
      infoId = parent.getAttribute(ZZ_INFO_ID);
    }
    if (url === undefined || url === null) {
      url = parent.getAttribute(ZZ_URL);
    }
    if (backupInfo === undefined || backupInfo === null) {
      backupInfo = parent.getAttribute(ZZ_BACKUP);
    }
    // 获取 父节点 ，直到有 sectionId 或者 没有父节点为止
    parent = parent.parentElement;
  }

  // 如果有 zz-nosendclick 属性，则不发送
  if (nosend === '1') return;
  // 整个 dom 树没有 sectionId 则退出
  if (!sectionId) return;

  // 格式化 上报参数
  sortId = sortId || '0';
  other = other || '0';
  sortName = sortName || '';
  infoId = infoId || '';
  if (url) {
    var urlParsed = new Url(url);
    jumpurl = urlParsed.origin + urlParsed.pathname + urlParsed.hash;
    jumppagequery = urlParsed.query.slice(1);
  }
  if (backupInfo) {
    try {
      backupInfo = JSON.parse(backupInfo);
    } catch (e) {
      backupInfo = {};
    }
  } else {
    backupInfo = {};
  }
  try {
    // cookies中设置refsectionId和refsortId
    setCookie({
      refsectionId: encodeURIComponent(sectionId)
    });
    setCookie({
      refsortId: sortId
    });
  } catch (error) {}
  if (sectionId) {
    backupInfo.sectionId = sectionId;
  }
  if (sortId) {
    backupInfo.sortId = sortId;
  }
  if (sortName) {
    backupInfo.sortName = sortName;
  }
  if (infoId) {
    backupInfo.infoId = infoId;
  }
  if (jumpurl) {
    backupInfo.jumpurl = jumpurl;
  }
  if (jumppagequery) {
    backupInfo.jumppagequery = jumppagequery;
  }
  sendData({
    pagetype: 'zpmclick',
    actiontype: pageIdInfo === null || pageIdInfo === void 0 ? void 0 : pageIdInfo.pageId,
    backup: backupInfo
  });
}
var initClickEventLIster = function initClickEventLIster() {
  if (!window || !window.addEventListener) return;
  // document.removeEventListener('click', clickCallback, true);
  // 监听整个 dom 树 click，检测是否命中符合 zpmclick 上报规则，注意性能问题
  document.addEventListener('click', clickCallback, true);
};
export default initClickEventLIster;